<template>
  <v-card>
    <v-card-title> Remainder of estate </v-card-title>
    <v-card-text>
      <v-row
        v-if="
          testator.remainderOfEstate && testator.remainderOfEstate.distribution
        "
      >
        <v-col cols="12" lg="12">
          <h4>Distribution:</h4>
          <p>{{ remainderOfEstateDistribution }}</p>
          <ul
            v-if="
              testator.remainderOfEstate.distribution == 'SPECIFIC_PERCENTAGES'
            "
          >
            <li
              v-for="specificPercentage in distributionSpecificPercentages"
              :key="'DSP' + specificPercentage.id"
            >
              {{ specificPercentage.beneficiaryDisplayName }} -
              {{ specificPercentage.percentage }}%
              <ul>
                <li
                  v-for="dspab in specificPercentage.distributionSpecificPercentageAlternativeBeneficiaries"
                >
                  Alternative:
                  {{
                    dspab.beneficiaryType !== 'Person'
                      ? `(${dspab.beneficiaryType})`
                      : ''
                  }}
                  - {{ dspab.beneficiaryDisplayName }} - {{ dspab.percentage }}%
                </li>
              </ul>
            </li>
          </ul>
        </v-col>

        <v-col
          v-if="
            testator.remainderOfEstate.distribution != 'SPECIFIC_PERCENTAGES'
          "
          cols="12"
          lg="6"
        >
          <h4>Alternative distribution:</h4>
          <p>{{ remainderOfEstateAlternativeDistribution }}</p>
          <ul
            v-if="
              testator.remainderOfEstate.alternativeDistribution ==
              'SPECIFIC_PERCENTAGES'
            "
          >
            <li
              v-for="specificPercentage in testator.remainderOfEstate
                .alternativeDistributionSpecificPercentages"
              :key="'ADSP' + specificPercentage.id"
            >
              {{ specificPercentage.beneficiaryDisplayName }} -
              {{ specificPercentage.percentage }}%
            </li>
          </ul>
        </v-col>

        <v-col
          v-if="testator.remainderOfEstate.familyObliterationEnabled"
          cols="12"
          lg="6"
        >
          <h4>Family Obliteration:</h4>
          <p v-if="familyObliterationEqualShares">In equal shares between:</p>
          <ul>
            <li
              v-for="nominee in familyObliterationNominees"
              :key="'FON' + nominee.id"
            >
              {{ nominee.beneficiaryDisplayName }}
              <span v-if="!familyObliterationEqualShares">
                - {{ nominee.percentage }}%
              </span>
            </li>
          </ul>
        </v-col>
      </v-row>

      <p v-else>No remainder of estate options selected</p>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: 'RemainderOfEstateCard',
    props: {
      testator: {
        required: true,
        type: Object,
      },
    },
    computed: {
      remainderOfEstateDistribution() {
        switch (this.testator.remainderOfEstate.distribution) {
          case 'SPOUSE':
            return 'Spouse/Partner';
          case 'CHILDREN':
            return 'Children';
          case 'SPOUSE_AND_CHILDREN':
            return 'Spouse/Partner and children';
          case 'SPECIFIC_PERCENTAGES':
            return 'Specific Percentages';
          case 'SHARIA_LAW':
            return 'Sharia Law';
          default:
            return '';
        }
      },
      remainderOfEstateAlternativeDistribution() {
        switch (this.testator.remainderOfEstate.alternativeDistribution) {
          case 'CHILDREN_OF_PREDECEASED':
            return 'Children of predeceased';
          case 'TESTATORS_CHILDREN':
            return "Testator's children";
          case 'DIVIDED_REMAINING_HEIRS':
            return 'Divided between remaining heirs';
          case 'SPECIFIC_PERCENTAGES':
            return 'Specific percentages';
          case 'UNBORN_CHILDREN':
            return 'Unborn children';
          default:
            return '';
        }
      },
      remainderOfEstate() {
        return this.testator.remainderOfEstate;
      },
      distributionSpecificPercentages() {
        return this.remainderOfEstate.distributionSpecificPercentages;
      },
      familyObliterationNominees() {
        return this.remainderOfEstate.familyObliterationNominees || [];
      },
      // Mirrors WillFacadeObject#family_obliteration_equal_shares? -- a single nominee takes
      // the whole remainder, so the will states 100% against their name rather than calling it
      // equal shares. Kept in step so the summary matches the generated document.
      familyObliterationEqualShares() {
        return (
          this.remainderOfEstate.familyObliterationEqualShares &&
          this.familyObliterationNominees.length > 1
        );
      },
    },
    methods: {
      specificPercentageAltDistribution(specificPercentage) {
        switch (specificPercentage.alternativeDistribution) {
          case 'BENEFICIARY_CHILDREN':
            return 'Beneficiary children';
          case 'SPECIFIC_CHARITY':
            return (
              'Specific charity - ' +
              specificPercentage.alternativeBeneficiaryDisplayName
            );
          case 'SPECIFIC_PERSON':
            return (
              'Specific person - ' +
              specificPercentage.alternativeBeneficiaryDisplayName
            );
          case 'SPECIFIC_TRUST':
            return (
              'Specific trust - ' +
              specificPercentage.alternativeBeneficiaryDisplayName
            );
          case 'DIVIDED_REMAINING_HEIRS':
            return 'Divided between remaining heirs';
        }
      },
    },
  };
</script>
